import { Component, input } from '@angular/core';
import { IUserSummary } from '@lb/api/mylb/interfaces';
import { UserIconComponent } from '@lb/components/user-icon/user-icon.component';

@Component({
	selector: 'lb-invoice-instructor-cell',
	templateUrl: './invoice-instructor-cell.component.html',
	styleUrls: ['./invoice-instructor-cell.component.scss'],
	imports: [UserIconComponent],
	standalone: true
})
export class InvoiceInstructorCellComponent {
	instructorUserID = input.required<number>();
	instructor = input.required<IUserSummary | undefined>();
}
